<script setup lang="ts">
import {VsgFlexWrapper} from '@jack-henry/jha-vue-components'
import type IAccount from '@/common/models/IAccount'
import ProductTypeIcon from '@/common/components/product-type-icon/productTypeIcon.vue'

export interface PropList {
  account: IAccount
  hideIcon: boolean
}

const props = withDefaults(defineProps<PropList>(), {
  hideIcon: false
})
</script>
<template>
  <vsg-flex-wrapper>
    <product-type-icon
      v-if="!hideIcon"
      fill-color="var(--jha-color-primary)"
      :group-type-code="account.accountGroup" />
    <div class="account-text-block">
      <div class="jh-font-body-medium-1 jha-text-dark">{{ account.accountMinorDescription }}</div>
      <div class="jh-font-helper-regular jha-text-light">{{ account.accountMajorDescription }}</div>
    </div>
  </vsg-flex-wrapper>
</template>

<style scoped>
@import '../../../branchmanager/assets/typography.css';
@import '../../../branchmanager/assets/typography-colors.css';

.account-text-block {
  flex: 1 1 auto;
  padding-right: var(--jh-space-400);
}
</style>
